import { createResizeHandler } from './resizeHandler';
import { createListItemManager } from './listItemManager';
import * as Sentry from '@sentry/browser';

export const MainNavigation = (mainNavigationSelector: HTMLElement) => {
  if (!mainNavigationSelector) {
    Sentry.captureException('MainNavigation: Element hlavní navigace nenalezen.');
    return;
  }
  const mainList: HTMLElement | null = mainNavigationSelector.querySelector('[data-main-nav-list]');
  if (!mainList) {
    Sentry.captureException('MainNavigation: Hlavní menu nenalezeno.');
    return;
  }
  const listItemManager = createListItemManager(mainList);
  const handleResize = createResizeHandler(mainNavigationSelector, mainList, listItemManager);
  handleResize();
};

export default MainNavigation;
